export default {
  drawer: null,
  bar: true,
  color: 'primary',
}
